<template>
    <el-dialog title="这是消息的标题" :visible.sync="addData.isshow" width="45%">
            <el-form label-width="120px">
                <span>这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息这是一条新的消息</span>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="addData.isshow = false">{{ $t('common.confirm') }}</el-button>
                <!-- <el-button type="primary" @click="saveAdd">确 定</el-button> -->
            </span>
        </el-dialog>
</template>

<script>
export default {
    data: function() {
        return {
            addData:{isshow:true,scope:null,index:0,data:{}},
        };
    },
    methods: {

    },
};
</script>

<style scoped>

</style>